import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex p-4" }
const _hoisted_2 = { class: "pl-2 gray-text" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, " Aceptar ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, " Volver ")
], -1)
const _hoisted_5 = { class: "flex p-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "pl-2 gray-text" }, [
  /*#__PURE__*/_createTextVNode(" Estás a punto de realizar un ajuste sobre una nómina en estado "),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("b", { style: {"color":"#00805d"} }, "Transmitido")
  ]),
  /*#__PURE__*/_createTextVNode(", selecciona la opción que deseas ejecutar: ")
], -1)
const _hoisted_7 = { class: "flex align-items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", { style: {"color":"#00805d"} }, "Eliminar")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "gray-text" }, " una nómina previamente transmitida", -1)
const _hoisted_10 = { class: "flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", { style: {"color":"#00805d"} }, "Modificar")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "gray-text" }, " la información de una nómina previamente transmitida ", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "btn-ajuste-container" }
const _hoisted_15 = {
  key: 0,
  class: "PopUpVideo_video"
}
const _hoisted_16 = {
  id: "video",
  class: "PopUpVideo_video_player",
  controls: "",
  ref: "VideoNominaAjustePortal"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "p-dialog-header-close-icon pi pi-times" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PayrollDeleteDialog = _resolveComponent("PayrollDeleteDialog")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PayrollAdjustDialog = _resolveComponent("PayrollAdjustDialog")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransmitirNomina = _resolveComponent("TransmitirNomina")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.tipoAjuste == $setup.TipoNota.Eliminar)
      ? (_openBlock(), _createBlock(_component_PayrollDeleteDialog, {
          key: 0,
          id: "confirm-dialog",
          draggable: false
        }, {
          message: _withCtx((props) => [
            _createTextVNode(_toDisplayString(props.message.message) + " ", 1),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("p", _hoisted_2, [
                _createTextVNode(" Estás a punto de realizar un ajuste que eliminará la información transmitida para la nómina del periodo "),
                _createElementVNode("span", null, [
                  _createElementVNode("b", null, _toDisplayString($setup.periodo), 1)
                ]),
                _createTextVNode(" de "),
                _createElementVNode("span", null, [
                  _createElementVNode("b", null, _toDisplayString($setup.empleado.fullName), 1)
                ]),
                _createTextVNode(" identificado con el documento "),
                _createElementVNode("span", null, [
                  _createElementVNode("b", null, _toDisplayString($setup.empleado.tipoIdentificacion) + "-" + _toDisplayString($setup.empleado.documentNumber), 1)
                ]),
                _createTextVNode(", en caso de estar seguro haz clic en el botón "),
                _hoisted_3,
                _createTextVNode(" de lo contrario haz clic en el botón "),
                _hoisted_4
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_PayrollAdjustDialog, {
      id: "confirm-dialog",
      draggable: false
    }, {
      message: _withCtx((props) => [
        _createTextVNode(_toDisplayString(props.message.message) + " ", 1),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_el_radio_group, {
            modelValue: $setup.tipoAjuste,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.tipoAjuste) = $event)),
            style: {"margin-left":"17%"},
            class: "gray-text"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_radio, {
                  label: $setup.TipoNota.Eliminar
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_radio, {
                  label: $setup.TipoNota.Reemplazar
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              ($setup.featureFlag)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              class: "btnPopUpNominaAjusteColor btnPopUpNominaAjuste",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.cerrarPopUp && $setup.cerrarPopUp(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'play-circle'],
                size: "sm"
              }),
              _createTextVNode(" Mira cómo se hace ")
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      visible: $setup.visiblePopUpIndividual,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (($setup.visiblePopUpIndividual) = $event)),
      width: "60%",
      higth: "30%",
      top: "",
      closable: false
    }, {
      header: _withCtx(() => [
        _createElementVNode("button", {
          class: "p-dialog-header-icon p-dialog-header-close p-link",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.detenerVideo && $setup.detenerVideo(...args))),
          style: {"margin-left":"95%"}
        }, _hoisted_19)
      ]),
      default: _withCtx(() => [
        ($setup.urlvd != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("video", _hoisted_16, [
                _createElementVNode("source", {
                  src: $setup.urlvd,
                  type: "video/mp4"
                }, null, 8, _hoisted_17)
              ], 512)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    ($setup.store.state.Transmitir)
      ? (_openBlock(), _createBlock(_component_TransmitirNomina, {
          key: 1,
          empleadoId: $setup.empleadoId,
          nominaEmpleado: $setup.nominaEmpleado
        }, null, 8, ["empleadoId", "nominaEmpleado"]))
      : _createCommentVNode("", true)
  ], 64))
}